export const ApiUrl = {
  authlogin: "/auth/login",
  user: "/user",
  role: "/role",
  configuration: "/configuration",
  permission: "/permission",
  ActivityLog: "/configuration/activity-logs",
  career: "/careerapi",
  careerapply: "/careerapply",
  banner: "/banner",
  image: "/uploads",
  confImageUpload: "/configuration/imageUpload",
};
export const ConfUrl = {
  home: "/home",
  about: "/about",
  turkey: "/turkey",
  productRange: "/productRange",
  valves: "/valves",
  career: "/career",
  footer: "/footer",
  contact: "/contact",
  element: "/element",
  quality: "/quality",
};
